import { Document, Page } from '@react-pdf/renderer'
import moment from 'moment'

import { MesureResponseModel, QuestionMeasure } from '@/domain/model/measures'
import { LevelCategoryModel } from '@/pages/ClientDetails/ClientMeasures/utils/transformLevelsToCategories'

import { globalPDFStyles } from '../styles'
import { MeasurePDFHeader, MeasuresPDFScores } from './Components'
import { MeasuresPDFChart } from './Components/Chart'
import { MeasuresPDFFooter } from './Components/Footer'
import { MeasurePDFInstructions } from './Components/Instructions'
import { MeasurePDFTable } from './Components/Table'

export type MeasuresPDFProps = {
  measureData?: MesureResponseModel
  question?: QuestionMeasure
  latestScore: number
  average: string | number
  totalAssessments?: number
  level?: LevelCategoryModel
  chartImage: string | null
  patient: {
    firstName: string
    lastName: string
    birthdate: string
  }
}
export const MeasuresPDF = (props: MeasuresPDFProps) => {
  const today = moment().format('MM-DD-YYYY[T]hh[h]mm[m]ss[s]')
  const titleDocument = `measures-${today}`
  if (!props.measureData) return null
  return (
    <Document title={titleDocument}>
      <Page size="A4" style={globalPDFStyles.body}>
        <MeasurePDFHeader {...props} />
        <MeasuresPDFScores {...props} />
        <MeasurePDFInstructions {...props} />
        <MeasuresPDFChart chartImage={props.chartImage} />
        <MeasurePDFTable
          measureData={props.measureData}
          questionId={String(props.question?.id)}
        />

        <MeasuresPDFFooter {...props} />
      </Page>
    </Document>
  )
}
